import React from 'react';
import { SkeletonLine } from '@wix/wix-ui-tpa/cssVars';
import { st, classes } from './Skeleton.st.css';
import { DataHooks } from './DataHooks';

export const Skeleton = ({
  isLine = false,
  className,
}: {
  isLine?: boolean;
  className?: string;
}) => (
  <SkeletonLine
    data-hook={DataHooks.Root}
    className={st(classes.root, { isLine }, className)}
  />
);
